import SolelyCard from './solely-card.vue'
export default SolelyCard



// WEBPACK FOOTER //
// ./src/components/solely-card/index.js